/** French candidate strings — screening. Key = the exact English text passed to t(), value = French. */
const fr = {
  // ── Journey steps (ScreeningApply / ScreeningResumeUpload timeline) ──
  'Basic details': 'Informations de base',
  'Resume upload': 'Envoi du CV',
  'Additional details': 'Informations complémentaires',
  Assessment: 'Évaluation',
  'AI interview': 'Entretien IA',
  'AI video interview': 'Entretien vidéo IA',
  'AI voice interview': 'Entretien vocal IA',
  'Application form': 'Formulaire de candidature',
  'Step {n}': 'Étape {n}',
  'Your screening journey': 'Votre parcours de présélection',
  'Powered by': 'Propulsé par',

  // ── ScreeningApply ──
  'Resume your application': 'Reprendre votre candidature',
  'Continue your screening': 'Poursuivre votre présélection',
  'You started this screening earlier. Continue from the resume and details step on this device.':
    'Vous avez commencé cette présélection plus tôt. Reprenez à l’étape du CV et des informations sur cet appareil.',
  'You can return to your screening hub to finish the assessment or interview.':
    'Vous pouvez revenir à votre espace de présélection pour terminer l’évaluation ou l’entretien.',
  Continue: 'Continuer',
  '1 hour': '1 heure',
  '{h} hours': '{h} heures',
  '{h} hour': '{h} heure',
  '{h} hr {m} mins': '{h} h {m} min',
  '{n} minutes': '{n} minutes',
  'Submitting…': 'Envoi en cours…',
  Next: 'Suivant',
  'Continue to Screening': 'Continuer vers la présélection',
  'Submit Application': 'Envoyer la candidature',
  Position: 'Poste',
  'Thank you for applying': 'Merci pour votre candidature',
  'Your application has been received.': 'Votre candidature a bien été reçue.',
  'No further steps needed. The recruiter will review your profile.':
    'Aucune autre étape n’est nécessaire. Le recruteur examinera votre profil.',
  'Step A': 'Étape A',
  'Step B': 'Étape B',
  'Take assessment': 'Passer l’évaluation',
  'Take AI video interview': 'Passer l’entretien vidéo IA',
  'Take AI voice interview': 'Passer l’entretien vocal IA',
  'This application link is no longer active': 'Ce lien de candidature n’est plus actif',
  'The recruiter has disabled this link.': 'Le recruteur a désactivé ce lien.',
  'Privacy Policy': 'Politique de confidentialité',
  Decline: 'Refuser',
  'I Accept': 'J’accepte',
  'Ready to begin?': 'Commencer maintenant ?',
  'Please start only if you meet the requirements below': 'Ne commencez que si vous remplissez les conditions ci-dessous',
  'Important guidelines': 'Consignes importantes',
  'Once started, you will have only {time} to complete this.':
    'Dès le démarrage, vous ne disposerez que de {time} pour tout terminer.',
  'Keep the below documents ready:': 'Préparez les documents suivants :',
  'Resume / CV': 'CV',
  'Required Document': 'Document requis',
  'Identity & Verification Documents (PAN, Aadhaar, etc.)': 'Pièces d’identité et justificatifs (PAN, Aadhaar, etc.)',
  'Video will be recorded (Proctored)': 'La vidéo sera enregistrée (surveillance)',
  'Camera might be turned on': 'La caméra pourra être activée',
  'Ensure a quiet, distraction-free space': 'Installez-vous dans un endroit calme et sans distractions',
  'Do not cheat or switch tabs': 'Ne trichez pas et ne changez pas d’onglet',
  'Find a quiet space. No cheating (your video and audio are recorded).':
    'Installez-vous dans un endroit calme. Aucune triche (votre vidéo et votre audio sont enregistrés).',
  'Find a quiet space. No cheating (your audio is recorded).':
    'Installez-vous dans un endroit calme. Aucune triche (votre audio est enregistré).',
  'Dress appropriately and stay seated.': 'Ayez une tenue correcte et restez en position assise.',
  'Dress appropriately.': 'Ayez une tenue correcte.',
  'Not now': 'Pas maintenant',
  'Starting…': 'Démarrage…',
  "I'm ready, let's go": 'C’est parti, je commence',
  'Job Description': 'Description du poste',
  "You've been shortlisted for {job} at {company}.":
    'Votre candidature a été présélectionnée pour le poste de {job} chez {company}.',
  "You've been shortlisted for {job}.": 'Votre candidature a été présélectionnée pour le poste de {job}.',
  'You will have approximately {time} to complete all screening steps once you press {button}. Choose a quiet, distraction‑free environment and ensure you have a stable internet connection.':
    'Vous disposerez d’environ {time} pour terminer toutes les étapes de la présélection après avoir cliqué sur {button}. Choisissez un environnement calme, sans distractions, et assurez-vous de disposer d’une connexion Internet stable.',
  'View JD': 'Voir l’offre',
  'About {company}': 'À propos de {company}',
  'About the company': 'À propos de l’entreprise',
  'What to Expect': 'Déroulement',
  'Resume Upload': 'Envoi du CV',
  'Please keep a soft copy of your resume (PDF or Word) ready to upload.':
    'Préparez une version numérique de votre CV (PDF ou Word) à envoyer.',
  'Document Upload': 'Envoi des documents',
  'Please keep digital copies of your background verification documents (like Aadhaar or PAN card) ready to upload.':
    'Préparez des copies numériques de vos documents de vérification (comme la carte Aadhaar ou PAN) à envoyer.',
  'Online Assessment': 'Évaluation en ligne',
  'Your video and audio will be recorded for proctoring. Ensure a quiet environment and do not switch tabs.':
    'Votre vidéo et votre audio seront enregistrés à des fins de surveillance. Installez-vous dans un endroit calme et ne changez pas d’onglet.',
  'Please allow camera access and choose a quiet place with minimal distractions before you begin.':
    'Autorisez l’accès à la caméra et choisissez un endroit calme, avec le moins de distractions possible, avant de commencer.',
  'AI Interview': 'Entretien IA',
  'An AI will ask you questions. It will be a simple conversation to understand your skills. ensure your {video} is on and you are presentable/in a formal setting':
    'Une IA vous posera des questions. Il s’agit d’une simple conversation pour comprendre vos compétences. Assurez-vous que votre {video} est activée et que votre tenue et votre cadre sont professionnels.',
  video: 'vidéo',
  'Basic Details': 'Informations de base',
  'Enter your details to begin.': 'Saisissez vos informations pour commencer.',
  'Full name': 'Nom complet',
  'Your full name': 'Votre nom complet',
  Email: 'E-mail',
  'you@example.com': 'vous@exemple.com',
  'Phone number': 'Numéro de téléphone',
  '(optional)': '(facultatif)',
  'e.g. 98765 43210': 'ex. 98765 43210',
  'Date of Birth': 'Date de naissance', // default registration field label (server identityDobField.js)
  // Default registration fields (server/config/orgDefaults.js)
  'Full Name': 'Nom complet',
  'Enter your full name': 'Saisissez votre nom complet',
  'Email Address': 'Adresse e-mail',
  'Enter your email': 'Saisissez votre adresse e-mail',
  'Phone Number': 'Numéro de téléphone',
  'Enter your phone number': 'Saisissez votre numéro de téléphone',
  'Select...': 'Sélectionner…',
  'Search {field}...': 'Rechercher : {field}…',
  option: 'une option',
  'No options found.': 'Aucune option trouvée.',
  'dd/mm/yyyy': 'jj/mm/aaaa',
  'Code (4 digit numerical)': 'Code (4 chiffres)', // utils/storeFormat.js
  'Store Code (e.g. LF-PT-PV01)': 'Code du magasin (ex. LF-PT-PV01)', // utils/storeFormat.js
  'e.g. {example}': 'ex. {example}',
  "Please enter the store code provided by your Store Manager. If you don't have it, please ask the person who shared this screening link with you.":
    'Veuillez saisir le code du magasin fourni par votre responsable de magasin. Si vous ne l’avez pas, demandez-le à la personne qui vous a transmis ce lien de présélection.',
  "Please enter the 4-digit code provided by your Store Manager. If you don't have it, please ask the person who shared this screening link with you.":
    'Veuillez saisir le code à 4 chiffres fourni par votre responsable de magasin. Si vous ne l’avez pas, demandez-le à la personne qui vous a transmis ce lien de présélection.',
  City: 'Ville',
  'Selected City': 'Ville sélectionnée',
  'Select your City': 'Sélectionnez votre ville',
  'Search city, state or region...': 'Rechercher une ville, un État ou une région…',
  'No cities found.': 'Aucune ville trouvée.',
  "I agree to {company}'s {notice} for processing my personal data":
    'J’accepte la {notice} de l’entreprise {company} pour le traitement de mes données personnelles',
  'the employer': 'l’employeur',
  'Consent Notice': 'notice de consentement',
  'Open the notice to read it and agree.': 'Ouvrez la notice pour la lire et l’accepter.',
  'I agree to the TalentCrux {terms} and {privacy}': 'J’accepte les {terms} et la {privacy} de TalentCrux',
  'Terms of Use': 'Conditions d’utilisation',
  'Upload your resume': 'Envoyez votre CV',
  'Upload a recent resume so we can understand your experience.':
    'Envoyez un CV récent afin que nous puissions comprendre votre expérience.',
  'Resume (PDF, DOCX, JPG, PNG)': 'CV (PDF, DOCX, JPG, PNG)',
  'Selected:': 'Fichier sélectionné :',
  'Click to choose file': 'Cliquez pour choisir un fichier',
  Screening: 'Présélection',
  'Screening ID:': 'Identifiant de la présélection :',
  // ScreeningApply inline errors
  'Please enter your Date of Birth in DD/MM/YYYY format.': 'Veuillez saisir votre date de naissance au format JJ/MM/AAAA.',
  'Please enter a valid Date of Birth in DD/MM/YYYY format.':
    'Veuillez saisir une date de naissance valide au format JJ/MM/AAAA.',
  'Please read and agree to the consent notice to continue.':
    'Veuillez lire et accepter la notice de consentement pour continuer.',
  'Please accept the consent to continue.': 'Veuillez donner votre consentement pour continuer.',
  'Unable to start your screening timer. Please try again.':
    'Impossible de démarrer le minuteur de votre présélection. Veuillez réessayer.',
  'Failed to submit your application. Please try again.': 'Échec de l’envoi de votre candidature. Veuillez réessayer.',
  'Unable to continue. Please check your details and try again.':
    'Impossible de continuer. Veuillez vérifier vos informations et réessayer.',
  'Failed to submit application. Please try again.': 'Échec de l’envoi de la candidature. Veuillez réessayer.',

  // ── ScreeningResumeUpload ──
  'Extracting text from document…': 'Extraction du texte du document…',
  'Analyzing resume content…': 'Analyse du contenu du CV…',
  'Parsing candidate information…': 'Lecture de vos informations…',
  'Running AI evaluation…': 'Évaluation par l’IA en cours…',
  'Almost there, finalizing details…': 'Presque terminé, finalisation des détails…',
  'Processing your resume': 'Traitement de votre CV',
  'This may take a few minutes depending on the document size.':
    'Cela peut prendre quelques minutes selon la taille du document.',
  'Please do not close this window.': 'Veuillez ne pas fermer cette fenêtre.',
  'Welcome back — we restored your saved details on this device.':
    'Bon retour — nous avons restauré les informations enregistrées sur cet appareil.',
  'Your session expired. Please confirm your details to restart.':
    'Votre session a expiré. Veuillez confirmer vos informations pour recommencer.',
  'Start from the apply page': 'Recommencez depuis la page de candidature',
  "We couldn't find your details on this device. Enter your information again from step one, or use the same browser you started with.":
    'Nous n’avons pas trouvé vos informations sur cet appareil. Saisissez-les à nouveau depuis la première étape, ou utilisez le même navigateur qu’au départ.',
  'Go to basic details': 'Aller aux informations de base',
  'The recruiter has disabled this link, so applications are no longer being accepted. If you believe this is an error, please contact the recruiter or company directly.':
    'Le recruteur a désactivé ce lien : les candidatures ne sont plus acceptées. Si vous pensez qu’il s’agit d’une erreur, contactez directement le recruteur ou l’entreprise.',
  'Loading…': 'Chargement…',
  'Upload within {time}': 'Temps restant : {time}',
  'Upload your resume to continue.': 'Envoyez votre CV pour continuer.',
  'Review your details to continue.': 'Vérifiez vos informations pour continuer.',
  "We can't connect to our servers from this browser.": 'Impossible de se connecter à nos serveurs depuis ce navigateur.',
  'If you opened this link from WhatsApp or another app, please copy the link and open it directly in Chrome or Safari. Switching between WiFi and mobile data can also help.':
    'Si vous avez ouvert ce lien depuis WhatsApp ou une autre application, copiez-le et ouvrez-le directement dans Chrome ou Safari. Passer du Wi-Fi aux données mobiles (ou inversement) peut aussi aider.',
  "You had a resume selected earlier on this device. Browsers can't keep the file after a refresh — please attach your resume again to continue.":
    'Vous aviez sélectionné un CV plus tôt sur cet appareil. Les navigateurs ne peuvent pas conserver le fichier après une actualisation — veuillez joindre à nouveau votre CV pour continuer.',
  Resume: 'CV',
  '{size} MB': '{size} Mo',
  'Uploading…': 'Envoi en cours…',
  Uploaded: 'Envoyé',
  'Remove file': 'Retirer le fichier',
  'Click anywhere in this box or drag a different file to replace the uploaded resume.':
    'Cliquez n’importe où dans cette zone ou faites glisser un autre fichier pour remplacer le CV envoyé.',
  'Supported: PDF, DOC, DOCX, JPG, PNG · Max 10MB': 'Formats acceptés : PDF, DOC, DOCX, JPG, PNG · 10 Mo max.',
  'Drag & drop your resume here': 'Glissez-déposez votre CV ici',
  'or click to browse a file from your device': 'ou cliquez pour choisir un fichier sur votre appareil',
  'Are transcripts available for each semester/year?': 'Disposez-vous des relevés de notes pour chaque semestre/année ?',
  "Time's up": 'Temps écoulé',
  'Continue to screening': 'Continuer vers la présélection',
  Finish: 'Terminer',
  // ScreeningResumeUpload inline errors
  "This file looks empty (0 KB). If it's stored in Google Drive or iCloud, downloading it to your device first usually fixes it — but you can still continue.":
    'Ce fichier semble vide (0 Ko). S’il est enregistré dans Google Drive ou iCloud, le télécharger d’abord sur votre appareil résout généralement le problème — mais vous pouvez tout de même continuer.',
  'Your basic details were not found. Please go back and fill them again.':
    'Vos informations de base sont introuvables. Veuillez revenir en arrière et les saisir à nouveau.',
  'Please attach your resume before continuing. If tapping the upload box does nothing, try opening this link in Chrome, or reply to the recruiter to send your resume by email.':
    'Veuillez joindre votre CV avant de continuer. Si rien ne se passe lorsque vous touchez la zone d’envoi, essayez d’ouvrir ce lien dans Chrome, ou répondez au recruteur pour lui envoyer votre CV par e-mail.',
  'We couldn’t reach the server. Please check your connection and try uploading again.':
    'Impossible de joindre le serveur. Veuillez vérifier votre connexion et réessayer l’envoi.',
  'Failed to submit your application. Please try again in a moment.':
    'Échec de l’envoi de votre candidature. Veuillez réessayer dans un instant.',

  // ── ScreeningHub ──
  'Failed to load screening.': 'Impossible de charger la présélection.',
  'Screening not found.': 'Présélection introuvable.',
  'No assessment, interview, or document submission steps for this screening.':
    'Cette présélection ne comporte aucune évaluation, aucun entretien ni aucun envoi de documents.',
  "You're done. We'll be in touch if your profile matches.":
    'C’est terminé. Nous vous contacterons si votre profil correspond.',
  'Complete document collection first to unlock this step.':
    'Terminez d’abord l’envoi des documents pour débloquer cette étape.',
  'Complete the application form first to unlock this step.':
    'Remplissez d’abord le formulaire de candidature pour débloquer cette étape.',
  'Redirecting…': 'Redirection…',
  'Screening steps': 'Étapes de la présélection',
  "Complete each step below to submit your application. You'll return here after each step.":
    'Terminez chacune des étapes ci-dessous pour envoyer votre candidature. Vous reviendrez ici après chaque étape.',
  "Complete the step below to submit your application. You'll return here when done.":
    'Terminez l’étape ci-dessous pour envoyer votre candidature. Vous reviendrez ici à la fin de l’étape.',
  'Duration: {minutes} min': 'Durée : {minutes} min',
  'You have completed this assessment.': 'Vous avez terminé cette évaluation.',
  'Complete and submit the assessment.': 'Répondez à l’évaluation et envoyez-la.',
  Completed: 'Terminé',
  'You have completed this interview.': 'Vous avez terminé cet entretien.',
  'Complete the assessment first to unlock this step.': 'Terminez d’abord l’évaluation pour débloquer cette étape.',
  'Complete the AI interview.': 'Passez l’entretien IA.',
  'Take interview': 'Passer l’entretien',
  'Complete the assessment first': 'Terminez d’abord l’évaluation',
  Documents: 'Documents',
  'You have completed this step.': 'Vous avez terminé cette étape.',
  'Upload the requested documents to unlock the next steps.':
    'Envoyez les documents demandés pour débloquer les étapes suivantes.',
  'Upload documents': 'Envoyer les documents',
  'You have submitted your application form.': 'Vous avez envoyé votre formulaire de candidature.',
  'Fill in your personal, education and work details. Your answers save as you type.':
    'Renseignez vos informations personnelles, votre formation et votre expérience professionnelle. Vos réponses sont enregistrées au fur et à mesure.',
  'Complete document collection first': 'Terminez d’abord l’envoi des documents',
  'Fill application form': 'Remplir le formulaire de candidature',

  // ── ScreeningThankYou ──
  'Screening Completed': 'Présélection terminée',
  'Thank you for your time and interest. Your screening process is now complete. We will review your profile and reach out if you are selected for the next stage.':
    'Merci pour votre temps et votre intérêt. Votre présélection est maintenant terminée. Nous examinerons votre profil et vous contacterons si votre candidature est retenue pour l’étape suivante.',
  'Thank you for completing your screening.': 'Merci d’avoir terminé votre présélection.',
  "We'll review your responses and follow up soon.": 'Nous examinerons vos réponses et reviendrons vers vous prochainement.',
  'Thank you for your feedback.': 'Merci pour votre avis.',
  'How would you rate your experience?': 'Comment évaluez-vous votre expérience ?',
  'Star rating': 'Note en étoiles',
  '{n} stars': '{n} étoiles',
  '{n} star': '{n} étoile',
  'Your valuable feedback': 'Votre avis',
  'Optional: share any comments or suggestions...': 'Facultatif : partagez vos commentaires ou suggestions…',
  'Failed to submit feedback. Please try again.': 'Échec de l’envoi de votre avis. Veuillez réessayer.',

  // ── ScreeningTimeUp ──
  'Your screening time is up': 'Le temps imparti pour votre présélection est écoulé',
  'Session closed': 'Session fermée',
  'Your screening time has ended. All responses have been saved.':
    'Le temps de votre présélection est terminé. Toutes vos réponses ont été enregistrées.',
  "We'll review your responses and follow up if there's a match.":
    'Nous examinerons vos réponses et reviendrons vers vous si votre profil correspond.',
  'Have questions? contact': 'Des questions ? Contactez',

  // ── Server messages a candidate can see (server/modules/jobs-dashboard/screenings.route.js:
  //    apply-info, start, basic-apply, apply) ──
  'This application link has reached its maximum candidate limit and is no longer active':
    'Ce lien de candidature a atteint le nombre maximal de candidatures et n’est plus actif',
  'This job posting is no longer accepting applications': 'Cette offre d’emploi n’accepte plus de candidatures',
  'Screening not found': 'Présélection introuvable',
  'Job not found': 'Offre d’emploi introuvable',
  'Invalid screening ID format': 'Format d’identifiant de présélection invalide',
  'Server error': 'Erreur du serveur',
  'Consent is required to start the screening': 'Votre consentement est requis pour commencer la présélection',
  'Name is required': 'Le nom est obligatoire',
  'Valid email is required': 'Une adresse e-mail valide est obligatoire',
  'You have already completed the screening for this role. Please wait—we will reach out to you if you are selected.':
    'Vous avez déjà terminé la présélection pour ce poste. Merci de patienter : nous vous contacterons si votre candidature est retenue.',
  'You have already completed the screening for this role. Please wait-we will reach out to you if you are selected.':
    'Vous avez déjà terminé la présélection pour ce poste. Merci de patienter : nous vous contacterons si votre candidature est retenue.',
  'A candidate with this email has already applied to this job':
    'Une candidature a déjà été envoyée pour ce poste avec cette adresse e-mail',
  'Invalid City selected': 'Ville sélectionnée invalide',
  'Your age is above the criteria for this role. Please contact your hiring manager or HR person for further assistance.':
    'Votre âge dépasse les critères fixés pour ce poste. Veuillez contacter votre responsable du recrutement ou le service RH pour obtenir de l’aide.',
  'Resume file (PDF, DOC, DOCX) is required': 'Un fichier CV (PDF, DOC, DOCX) est obligatoire',
  'We could not save your resume just now. Please try again in a moment.':
    'Nous n’avons pas pu enregistrer votre CV pour le moment. Veuillez réessayer dans un instant.',
  'A resume has already been submitted and scored for this application. Duplicate resume uploads are not accepted.':
    'Un CV a déjà été envoyé et évalué pour cette candidature. Les envois en double ne sont pas acceptés.',
};

export default fr;
